export const sellersListKey = () => ["sellers-list"];

export const sellersListParamsKey = ({ queryParams }) => [...sellersListKey(), queryParams];
